const sleep = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));

export const retryAsync = async <T>(
  asyncFn: () => Promise<T>,
  retries: number = 3,
  delay: number = 1000,
  backoff: boolean = true
): Promise<T> => {
  let lastError: Error | undefined;

  for (let i = 0; i < retries; i++) {
    try {
      return await asyncFn();
    } catch (error) {
      lastError = error as Error;
      if (i < retries - 1) {
        const delayTime = backoff ? delay * Math.pow(2, i) : delay;
        console.log(`Attempt ${i + 1} failed. Retrying in ${delayTime}ms...`);
        await sleep(delayTime);
      }
    }
  }
  throw lastError;
};